// import CampEthiccraft from "./Camps/Camps_Ethiccraft";
import CampGallery from "./Camps/CampGallery";
import ReviewsSection from "./Camps/Sliding_Reviews";
// import PolaroidImageSlider from "./Camps/Camp_Memories";

import "./Css/Camps.css";

function Camps() {
  return (
    <div className="camps">
      {/* <CampEthiccraft /> */}
      {/* <PolaroidImageSlider /> */}
      <CampGallery />
      <ReviewsSection />
    </div>
  );
}

export default Camps;
